import React, { useState } from "react";
import T from "prop-types";
import { Errors, Form as AppForm } from "MODULES/shared/components/Forms";
import {
  CONSIGNMENT,
  CONSIGNMENT_BUYER_ID,
  CONSIGNMENT_REFERENCE,
  CONSIGNMENT_REFERENCE_COMPANY_ID,
  CONSIGNOR_PERCENTAGE,
  EMA,
  MISTAKE_SHIPMENT,
  PO,
  RECEIVING_CHECKLIST_QUESTIONS,
  RECEIVING_TYPE
} from "MODULES/Receiving/constants";
import {
  CAAC,
  CONDITION,
  EASA,
  FAA,
  LOCATION,
  OTHER,
  OTHER_TAG_TYPE,
  PART_ID,
  SERIAL_NUMBER,
  TCCA,
  TRACE_TYPE,
  TRACED_TO
} from "MODULES/inventories/constants";
import { isEmpty } from "lodash";
import { onSuccess } from "LIB/submission";
import { LOT_ID, LOT_LINE_ITEM } from "MODULES/Lots/constants";
import { AWB_NUMBER, QUANTITY } from "APP_ROOT/constants";

function FormFooter({
  allValues,
  close,
  getInitialFieldValue,
  getField,
  propValues,
  removeItem,
  receiveAnother,
  receivingRecord,
  reset,
  save,
  setFieldValue,
  submitting,
  submitFailed,
  errorMessages,
  receivingType,
  handleSubmit,
  onSubmit
}) {
  const hasRemainingQuantity =
    Number(getInitialFieldValue(QUANTITY)) - Number(getField(QUANTITY)) > 0;

  const [localQtyReceived, setLocalQtyReceived] = useState(
    receivingRecord && receivingRecord.quantity_received
      ? receivingRecord.quantity_received
      : 0
  );
  const qtyOrdered =
    receivingRecord && receivingRecord.quantity ? receivingRecord.quantity : 0;
  const qtyUnreceived = qtyOrdered - localQtyReceived;
  const canReceiveAnother = receivingRecord && qtyUnreceived > 1;
  return (
    <AppForm.Footer>
      {submitFailed && <Errors errors={errorMessages} />}
      <AppForm.Cancel close={close} />
      <button
        disabled={submitting || receivingType === EMA}
        type="button"
        className="btn btn-danger"
        onClick={onSuccess(
          handleSubmit(values =>
            onSubmit({
              formData: {
                ...values,
                reported: true
              },
              lineItem: receivingRecord
            })
          ),
          close,
          propValues
        )}
      >
        Report Discrepancy
      </button>
      {!isEmpty(receivingType) &&
        ![EMA, MISTAKE_SHIPMENT, CONSIGNMENT, LOT_LINE_ITEM].includes(
          receivingType
        ) && (
          <button
            className="btn btn-warning "
            disabled={submitting}
            type="button"
            onClick={() => {
              save({
                id: allValues.reference_record_line_item_id,
                formData: allValues
              }).then(() => close());
            }}
          >
            {submitting ? (
              <i className="fa fa-cog fa-spin fa-fw fa-lg" />
            ) : (
              "Save"
            )}
          </button>
        )}
      <button
        disabled={submitting}
        className="btn btn-success"
        onClick={onSuccess(
          handleSubmit(values =>
            onSubmit({
              formData: {
                ...values
              },
              lineItem: receivingRecord
            })
          ),
          () => {
            removeItem(receivingRecord && receivingRecord.id);
            close();
          },
          propValues
        )}
      >
        {submitting ? (
          <i className="fa fa-cog fa-spin fa-fw fa-lg" />
        ) : (
          "Receive"
        )}
      </button>
      {([CONSIGNMENT, EMA, LOT_LINE_ITEM].includes(receivingType) ||
        (receivingType === PO && hasRemainingQuantity)) &&
        canReceiveAnother && (
          <button
            disabled={submitting}
            className="btn btn-success"
            onClick={onSuccess(
              handleSubmit(values =>
                onSubmit({
                  formData: {
                    ...values
                  },
                  lineItem: receivingRecord
                })
              ),
              () => {
                setLocalQtyReceived(prev => prev + 1);

                const savedVals = [
                  CONSIGNMENT_BUYER_ID,
                  CONSIGNMENT_REFERENCE_COMPANY_ID,
                  CONSIGNOR_PERCENTAGE,
                  CONSIGNMENT_REFERENCE,
                  FAA,
                  EASA,
                  CAAC,
                  TCCA,
                  OTHER,
                  OTHER_TAG_TYPE,
                  LOT_ID,
                  RECEIVING_TYPE,
                  TRACE_TYPE,
                  TRACED_TO
                ].reduce(
                  (agg, f) => ({
                    ...agg,
                    [f]: getField(f)
                  }),
                  {}
                );

                if (receivingType === LOT_LINE_ITEM) {
                  savedVals[AWB_NUMBER] = getField(AWB_NUMBER);
                } else if (receivingType === PO) {
                  savedVals[QUANTITY] = 1;
                  savedVals[SERIAL_NUMBER] = "";
                  Object.keys(RECEIVING_CHECKLIST_QUESTIONS)
                    .concat([
                      CONDITION,
                      LOCATION,
                      AWB_NUMBER,
                      "reference_record_line_item_id",
                      "reference_record_line_item_type",
                      PART_ID
                    ])
                    .forEach(k => {
                      savedVals[k] = getField(k);
                    });
                }

                reset();

                Object.keys(savedVals).forEach(k => {
                  setFieldValue(k)(savedVals[k]);
                });

                receiveAnother(receivingType);
              },
              propValues
            )}
          >
            {submitting ? (
              <i className="fa fa-cog fa-spin fa-fw fa-lg" />
            ) : (
              "Receive Another"
            )}
          </button>
        )}{" "}
    </AppForm.Footer>
  );
}

export default FormFooter;

FormFooter.propTypes = {
  allValues: T.shape({}),
  close: T.func.isRequired,
  errorMessages: T.shape({}),
  getField: T.func.isRequired,
  getInitialFieldValue: T.func.isRequired,
  propValues: T.shape({}),
  removeItem: T.func.isRequired,
  selectedConsignmentBuyer: T.shape({}),
  selectedConsignor: T.shape({}),
  receiveAnother: T.func.isRequired,
  receivingRecord: T.shape({}),
  reset: T.func.isRequired,
  save: T.func.isRequired,
  setFieldValue: T.func.isRequired,
  submitting: T.bool.isRequired,
  submitFailed: T.bool.isRequired,
  receivingType: T.string.isRequired,
  handleSubmit: T.func.isRequired,
  onSubmit: T.func.isRequired
};



// WEBPACK FOOTER //
// ./app/modules/Receiving/Dashboard/Create/FormFooter.jsx